/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Styles } from '@contently/toolkit';
import { Field } from 'react-final-form';
import styled from '@emotion/styled';
import InputHeightWrapper from './InputHeightWrapper';

const { Label, Input: ToolkitInput, ErrorWrapper } = Form;

const defaultBorder = `border-color: ${Styles.colors.grey.altLight};`;

const activeBorder = `border-color: ${Styles.colors.blue.primaryDark};`;

const StyledInput = styled(ToolkitInput)`
  ${props => (props.value === '' ? defaultBorder : activeBorder)}
  background: #F6F6F6;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom-width: 2px;
  border-radius: 3px 3px 0 0;

  &:focus,
  &:hover {
    ${activeBorder}
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-bottom-width: 2px;
  }
`;

const LabelCustom = styled(Label)`
  color: #0094ab;
  font-size: 12px;
  div[class*='Error'] {
    font-size: 10px;
    font-weight: 300;
  }
`;

const InputField = props => {
  const { name, validate } = props;

  const Input = ({ input, meta }) => {
    return (
      <LabelCustom style={{ width: '100%' }}>
        {name}
        <InputHeightWrapper>
          <ErrorWrapper touched={meta.touched} error={meta.error}>
            <StyledInput {...props} {...input} />
          </ErrorWrapper>
        </InputHeightWrapper>
      </LabelCustom>
    );
  };

  return <Field name={name} render={Input} validate={validate} />;
};

InputField.defaultProps = {
  validate: () => undefined
};

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func
};

export default InputField;
